export default __webpack_public_path__ + "static/media/Pit Fighter's Tattered Choker.6e7dd5ee.jpg";